import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import {
	REFRESH_TOKEN_MUTATION,
	SIGN_IN_QUERY,
	SIGN_OUT_MUTATION,
	SOCIAL_SIGN_IN_MUTATION,
} from '@app/model/_security/service/SecurityGraphQLQueries';
import PrincipalWithToken from '@app/model/_security/PrincipalWithToken';
import AuthProvider from '@app/model/authentication/AuthProvider';
import GoogleAuthenticationService from '@app/model/_security/service/GoogleAuthenticationService';
import Principal from '@app/model/authentication/Principal';
import { sendToBackgroundViaRelay } from '@plasmohq/messaging';
import useSiteState from '@app/state/SiteState';

class SecurityService {

	public static signIn = (input: { username: string, password: string }) => {
		return GraphQLExecutor.execute<PrincipalWithToken>(SIGN_IN_QUERY, input);
	};

	public static socialSignIn = async (input: {
		authProvider: AuthProvider,
		authProviderResponse: any
	}): Promise<PrincipalWithToken> => {

		switch (input.authProvider) {
			case AuthProvider.GOOGLE: {
				const userInfo: any = await GoogleAuthenticationService.fetchUserInfo(input.authProviderResponse.access_token);
				return await GraphQLExecutor.execute<PrincipalWithToken>(SOCIAL_SIGN_IN_MUTATION, {
					userId: userInfo.sub,
					username: userInfo.email,
					name: userInfo.name,
					authProvider: input.authProvider,
				});
			}
		}

		return Promise.reject('server.exception.authentication.USERNAME_DOES_NOT_EXIST');
	};

	public static signOut = async () => {
		try {
			await GraphQLExecutor.execute<PrincipalWithToken>(SIGN_OUT_MUTATION);
			useSiteState.getState().setSelectedCompanyHotelId(undefined);
			SecurityService.removeToken();
			return Promise.resolve();
		} catch (reason) {
			return await Promise.reject(reason);
		}
	};

	public static refreshToken = () => {
		return GraphQLExecutor.execute<PrincipalWithToken>(
			REFRESH_TOKEN_MUTATION,
		);
	};

	public static setToken = (token: string) => {
		useSiteState.getState().setToken(token);
	};

	public static getToken = () => {
		return useSiteState.getState().token;
	};

	public static removeToken = () => {
		useSiteState.getState().setToken(undefined);
		useSiteState.getState().setPrincipal(null);
		useSiteState.getState().setSelectedCompanyHotelId(undefined);
	};

	public static login = (principalWithToken: PrincipalWithToken) => {
		useSiteState.getState().setSelectedCompanyHotelId(undefined);
		SecurityService.setToken(principalWithToken.token);
		useSiteState.getState().setPrincipal(principalWithToken.principal);
		SecurityService.relayToExtension(principalWithToken.token, principalWithToken.principal);
	};

	public static relayToExtension = (token: string, principal: Principal) => {
		sendToBackgroundViaRelay({
			// @ts-ignore
			name: 'authentication',
			body: { action: 'signin', token: token, principal: principal },
		}).then(() => console.log('Authentication sent to background'));
	};
}

export default SecurityService;